<template>
  <v-navigation-drawer
    fixed
    style="margin-top: 65px"
    permanent
    @transitionend="onDrawerToggle"
    :style="{ width: drawerWidth + 'px', minWidth: minWidth + 'px' }"
    :class="mini ? 'mini' : ''"
    ref="drawer"
  >
    <div class="drawer-resizer">
      <div class="d-flex justify-center align-center ma-4">
        <div @click="handleMini">
          <v-icon v-if="mini === false">mdi-chevron-left</v-icon>
          <v-icon v-else>mdi-chevron-right</v-icon>
        </div>
        <h3
          class="text-center flex-grow-1"
          style="color: #384b6d; cursor: pointer"
          v-show="!mini"
        >
          {{ $tc("nav.groups") }}
        </h3>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              @click.stop="openAdd()"
              class="ml-auto"
              color="#384b6d"
              v-show="!mini"
              >mdi-plus</v-icon
            >
          </template>
          <span>{{ $tc("groups.addGroup") }}</span>
        </v-tooltip>
      </div>
      <v-treeview
        v-model="tree"
        dense
        transition
        return-object
        :open="initiallyOpen"
        :items="items"
        activatable
        item-key="id"
        open-on-click
        @update:active="onItemSelected"
        @update:open="onParentSelected"
        v-show="!mini"
      >
        <template v-slot:label="{ item, open }">
          <v-icon>{{ open ? "mdi-folder-open" : "mdi-folder" }}</v-icon>
          <span :data-level="item.level" @click="openDirectory(open)">{{
            item.son
          }}</span>
        </template>

        <template v-slot:append="{ item }">
          <div class="d-flex">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div class="center">
                    <v-icon id="icon-edit" @click.stop="openForm('edit', item)">
                      fas fa-pen
                    </v-icon>
                  </div>
                </span>
              </template>
              <span>{{ $tc("groups.editGroup") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <div class="center">
                    <v-icon
                      id="icon-delete"
                      v-if="!item.hasChildren"
                      @click.stop="openForm('delete', item)"
                    >
                      fas fa-trash
                    </v-icon>
                  </div>
                </span>
              </template>
              <span>{{ $tc("groups.deleteGroup") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-treeview>
    </div>
    <v-dialog
      v-model="openAddGroup"
      max-width="400px"
      persistent
      @keydown.esc="cancelFormAdd(false)"
    >
      <Form
        maxWidth="400px"
        @save="saveFormAdd"
        @cancel="cancelFormAdd"
        :items="dataInput"
        mode="Agregar grupo"
      />
    </v-dialog>
    <v-dialog
      v-model="openDialog"
      max-width="400px"
      persistent
      @keydown.esc="cancelForm(false)"
    >
      <Form
        :key="this.formKey"
        maxWidth="400px"
        :mode="mode"
        @save="saveForm"
        @cancel="cancelForm"
        :itemsSelect="dataSelects"
        :items="dataInput"
        :show="true"
      />
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-navigation-drawer>
</template>
<script>
import DeleteDialog from "../../Complement/DeleteDialog.vue";
import Form from "../../Complement/Form.vue";
import groups from "../../../store/groups/groups";
import employeesGroups from "../../../store/groups/employees";
import schedules from "../../../store/groups/schedules";
import models from "../../../store/groups/model";
import Loader from "../../Complement/Loader.vue";
export default {
  components: {
    Form,
    DeleteDialog,
    Loader,
  },

  data() {
    return {
      formKey: 0,
      titleDelete: "el grupo",
      drawerWidth: 300,
      isLoading: false,
      itemDelete: null,
      initiallyOpen: ["Digicard"],
      tree: [],
      mode: "",
      openAddGroup: false,
      dataInput: [
        {
          name: "group",
          label: this.$tc("groups.group"),
          data: "",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ],
      editItem: null,
      close: null,
      isLoading: false,
      mini: false,
      tempDrawerWidth: null,
      minWidth: 300,
    };
  },

  mounted() {
    this.initializeDrawerResize();
    groups.dispatch("getGroups");
    groups.dispatch("getSubGroups");
  },

  computed: {
    getGroups() {
      return groups.state.groups;
    },
    getSubGroups() {
      return groups.state.subGroups;
    },
    dataSelects() {
      return [
        {
          name: "subGroups",
          label: this.$tc("groups.subGroups"),
          data: [],
          items: this.getSubGroups,
          itemsValue: "groupId",
          itemsText: "name",
          rules: [],
        },
      ];
    },
    openDialog: {
      get() {
        return groups.state.openGroup;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return groups.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    items() {
      const groupsById = {};
      this.getGroups.forEach((group) => {
        groupsById[group.idSon] = {
          id: group.idSon,
          son: group.son,
          children: [],
          hasChildren: false,
          hasFather: null,
          father: group.id,
          fatherName: group.name,
          level: group.level,
        };
      });
      this.getGroups.forEach((group) => {
        if (group.id === null) {
          groupsById[group.idSon].hasFather = false;
        }
        const parent = groupsById[group.id];
        if (parent) {
          parent.hasChildren = true;
          groupsById[group.idSon].hasFather = true;
          parent.children.push(groupsById[group.idSon]);
        }
      });
      const rootGroups = this.getGroups.filter((group) => !group.hasAParent);
      return rootGroups.map((group) => groupsById[group.idSon]);
    },
  },

  methods: {
    handleMini() {
      this.mini = !this.mini;
      if (this.tempDrawerWidth !== null) {
        this.drawerWidth = this.tempDrawerWidth;
        this.tempDrawerWidth = null;
        this.minWidth = 300;
      } else {
        this.tempDrawerWidth = this.drawerWidth;
        this.drawerWidth = 60;
        this.minWidth = 60;
      }
    },
    onDrawerToggle(event) {
      if (this.minWidth <= this.drawerWidth) {
        if (this.minWidth === 60) {
          this.drawerWidth = 60;
          this.minWidth = 60;
        }
        const drawerWidth = parseInt(event.target.style.width);
        groups.commit("setPaddingNav", drawerWidth.toString() + "px");
      } else {
        this.drawerWidth = 300;
      }
    },
    async openForm(type, item) {
      switch (type) {
        case "add":
          groups.dispatch("getSubGroups").then(() => {
            groups.commit("setOpenGroup", true);
            this.mode = this.$tc("groups.addSubGroup");
          });

          break;
        case "edit":
          await groups.dispatch("getSubGroups").then(() => {
            this.mode = this.$tc("groups.editGroup");
            this.dataInput[0].data = item.son;
            this.dataSelects[0].data = item.father;
            groups.commit("setOpenGroup", true);
            this.editItem = {
              id: item.id,
              name: item.son,
              father: item.father,
              fatherName: item.fatherName,
              level: item.level,
            };
            this.formKey++;
          });

          break;
        case "delete":
          this.openDelete = true;
          groups.commit("setOpenDelete", true);
          this.itemDelete = item;
          break;

        default:
          break;
      }
    },
    loading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 800);
    },
    cancelFormAdd(value) {
      this.openAddGroup = value;
      this.dataInput[0].data = "";
    },

    deleteItem() {
      groups.commit("setDeleteItem", this.itemDelete);
      groups
        .dispatch("delete")
        .then(() => {
          if (this.itemDelete.hasFather) {
            groups.dispatch("getGroups");
          }
        })
        .catch((e) => {
          console.log(e);
        });
      this.cancelDelete();
    },
    saveFormAdd(items) {
      groups.commit("setNew", items);
      groups
        .dispatch("new")
        .then(() => {})
        .catch((e) => {
          console.log(e);
        });
      this.cancelFormAdd(false);
    },
    onItemSelected(selectedItems) {
      if (selectedItems.length > 0) {
        this.sendToComponent(selectedItems);
      }
    },
    onParentSelected(item) {
      if (item.length > 1) {
        item.splice(0, item.length - 1);
      }

      if (item.length > 0 && this.close == false) {
        this.sendToComponent(item);
      }
    },
    sendToComponent(itemSelected) {
      this.loading();
      groups.commit("setItemSelected", itemSelected[0]);
      employeesGroups.dispatch("getEmployees", itemSelected[0].id);
      schedules.dispatch("getSchedules", itemSelected[0].id);
      models.dispatch("getModels", itemSelected[0].id);
    },
    cancelForm(value) {
      groups.commit("setOpenGroup", value);
      this.dataInput.forEach((item) => {
        item.data = "";
      });
      this.dataSelects.forEach((item) => {
        item.data = [];
      });
    },
    openAdd() {
      this.openAddGroup = true;
    },
    cancelDelete() {
      this.openDelete = false;
      groups.commit("setOpenDelete", false);
    },
    openDirectory(open) {
      this.close = open;
    },

    saveForm(value) {
      let parseId = parseInt(value.subGroups, 10);
      const payload = {
        id: this.editItem.id,
        name: value.group,
        father: parseId,
        fatherName: !isNaN(parseId) ? this.searchFather(parseId, 10) : null,
        level: this.editItem.level,
        oldFather: this.editItem.father,
      };

      groups.commit("setEdit", payload);
      groups
        .dispatch("edit")
        .then(() => {
          groups.dispatch("getGroups");
        })
        .catch((e) => {
          console.log(e);
        });
      this.cancelForm(false);
    },
    searchFather(id) {
      const father = this.getGroups.find((group) => group.idSon === id);
      return father.son;
    },
    initializeDrawerResize() {
      const drawer = this.$refs.drawer.$el;
      const resizer = drawer.querySelector(".drawer-resizer");

      let startX = 0;
      let initialWidth = 0;

      const handleMouseMove = (event) => {
        const diffX = event.clientX - startX;
        this.drawerWidth = initialWidth + diffX;
      };

      const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };

      resizer.addEventListener("mousedown", (event) => {
        startX = event.clientX;
        initialWidth = drawer.offsetWidth;

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
      });
    },
  },
};
</script>
<style scoped>
.drawer-resizer {
  cursor: w-resize !important;
  min-height: 100%;
  margin-bottom: 64px;
}
.v-list-group__header__prepend-icon:before {
  color: rgb(31, 138, 238);
}
.selected-item {
  font-weight: bold !important;
  color: #82a1d0 !important;
}
.mini {
  max-width: 60px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
  margin-left: 10px;
}
</style>
